export default __webpack_public_path__ + "static/desktop_4-9075bbd9c2c6e0726fc0bd6ed1837928.webp";